import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import CustomSelect from 'components/atoms/dropdowns/custom-select';
import SwitchFrame from './switch-frame';

function getOption(value) {
    return {value, label: value};
}

class SiteSwitch extends Component {
    onChange(selected) {
        const value = selected?.value ?? '';
        this.props.dispatch(Action.set('SiteFilter', value));
    }

    renderOption(item) {
        return <SwitchFrame value={item.value} />;
    }

    render() {
        const {sportConfig} = this.props;

        const options = sportConfig.getSites().map((site) => getOption(site));
        const site = sportConfig.getSite();
        const value = site ? getOption(site) : '';

        return (
            <div className="site-cell" data-testid="site-dropdown">
                <label className="label-alt">Site</label>
                <CustomSelect
                    key={`site-${value}`}
                    defaultValue={value}
                    options={options}
                    value={value}
                    renderOption={::this.renderOption}
                    onChange={::this.onChange}
                />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    return {
        sportConfig: state.sportConfig,
    };
}

export default connect(mapStatesToProps)(SiteSwitch);
